import page from 'shared/pages'
import List from './List'
export default [
  {
    path: '',
    name: 'staff_list',
    component: page.createList(List),
  },
  {
    path: 'new',
    name: 'staff_new',
    component: () => import('./New'),
    props: true,
  },
  {
    path: ':id/edit',
    name: 'staff_edit',
    component: () => import('./Edit'),
    props: true,
  },
  {
    path: ':id',
    name: 'staff_detail',
    component: () => import('./Detail'),
    props: true,
  },
]
